module.exports = __webpack_public_path__ + "static/media/l-oreal@2x.7abb67f1.png";